import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllowanceVariableModule } from './allowance-variable/allowance-variable.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, AllowanceVariableModule],
  exports: [AllowanceVariableModule],
})
export class AllowanceModule {}
